










































import { Component, PropSync, Vue } from 'vue-property-decorator';

import DistributeUnallocatedBalanceSuccessViewModel
  from
  '@/vue-app/view-models/components/goals-dashboard/unallocated-balance/distribute-unallocated-balance-success-view-model';

@Component({
  name: 'DistributeUnallocatedBalanceSuccess',
})
export default class DistributeUnallocatedBalanceSuccess extends Vue {
  @PropSync('productName', { type: String, required: true })
  synced_product_name!: string;

  view_model = Vue.observable(
    new DistributeUnallocatedBalanceSuccessViewModel(this),
  );
}
